import _ from 'lodash';
import { Common } from './common';
import { Home } from './Home';

(function () {
  window.addEventListener('DOMContentLoaded', () => {
    Common.init();
    Home.init();
  });

  const handleResize = _.debounce(() => {
    Common.resize();
  });
  window.addEventListener('resize', handleResize);

  window.addEventListener('breakPoint', () => {
    Common.breakPoint();
  });
})();
